// import axios from 'axios'
import baseURL from '../baseUrl'

// 钱包金额
export function myWallet(data) {
  var url=baseURL?'/pc_getUserWallet':'/api/pc_getUserWallet'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
// 钱包明细
export function walletBill(data) {
  var url=baseURL?'/walletBill':'/api/walletBill'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//充值活动列表
export function activelist(data) {
  var url=baseURL?'/pc_rechargeActivityList':'/api/pc_rechargeActivityList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}
//微信支付
export function weixin(data) {
  var url=baseURL?'/wxPayRecharge':'/api/wxPayRecharge'
  return axios({
    // url: '/pc_activeweixin',
    url,
    method: 'post',
    params: data
  })
}
//支付宝支付
export function alipay(data) {
  var url=baseURL?'/pc_activealipay':'/api/pc_activealipay'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

//轮询充值结果
export function notificationStatus(data) {
  var url=baseURL?'/rechargeRefresh':'/api/rechargeRefresh'
  return axios({
    // url: '/pc_notificationStatus',
    url,
    method: 'post',
    params: data
  })
}


//支付密码
export function getUpdatePayPwd(data) {
  var url=baseURL?'/pc_getUpdatePayPwd':'/api/pc_getUpdatePayPwd'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


//充值协议
export function pcDocument(data) {
  var url=baseURL?'/pc_document':'/api/pc_document'
  return axios({
    url,
    method: 'post',
    params: data
  })
}

export function getUserLineRecordList(data) {
  var url=baseURL?'/getUserLineRecordList':'/api/getUserLineRecordList'
  return axios({
    url,
    method: 'post',
    params: data
  })
}


// WEBPACK FOOTER //
// ./src/api/my/mywallet.js